module.exports = __webpack_public_path__ + "static/media/img-bottom.be3723f2.svg";